module.exports = __webpack_public_path__ + "media/src/images/icons/link-a588991167cae94f4bb69f923ae6e0ba.svg";